const Style = {

  base: 'block w-[9em] h-[5em] mx-auto mb-4 outline-none'
  

}

export default Style;
